import * as React from 'react';
import { IconProps } from '../types';

const IcReferal = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M5.5 22a4 4 0 0 0 3.858-3h6.284a4.043 4.043 0 1 0 2.788-4.837l-3.114-5.327a4 4 0 1 0-5.63 0l-3.108 5.33A3.966 3.966 0 0 0 5.5 14a4 4 0 0 0 0 8Zm14-6a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm-7-12a2 2 0 1 1 0 4 2 2 0 0 1 0-4ZM11.42 9.834c.35.105.713.16 1.079.166a3.909 3.909 0 0 0 1.082-.168l3.111 5.323A4 4 0 0 0 15.642 17H9.358a3.994 3.994 0 0 0-1.044-1.838l3.107-5.328ZM5.5 16a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
    />
  </svg>
);

export default IcReferal;
